import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import NavbarTop from "../components/NavbarTop";

const LS_KEY = "sidebarCollapsed";

export default function AdminLayout() {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
        const v = localStorage.getItem(LS_KEY);
        return v === "1";
    });

    useEffect(() => {
        localStorage.setItem(LS_KEY, sidebarCollapsed ? "1" : "0");
    }, [sidebarCollapsed]);

    useEffect(() => {
        const onResize = () => {
            if (window.innerWidth >= 992) setSidebarOpen(false);
        };
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, []);

    return (
        <div className="app-shell bg-body-tertiary">
            <NavbarTop
                onMenu={() => setSidebarOpen(true)}
                sidebarCollapsed={sidebarCollapsed}
                onToggleSidebarCollapse={() => setSidebarCollapsed((v) => !v)}
            />

            {/* Below navbar: fixed height + no outer scroll */}
            <div className="app-body d-flex">
                {/* Desktop sidebar (scrolls inside only) */}
                <div className="d-none d-lg-block sidebar-scroll flex-shrink-0">
                    <Sidebar variant="desktop" collapsed={sidebarCollapsed} />
                </div>


                {/* Mobile sidebar drawer (overlay) */}
                <Sidebar
                    variant="mobile"
                    open={sidebarOpen}
                    onClose={() => setSidebarOpen(false)}
                />

                {/* Content scrolls inside only */}
                <main className="flex-grow-1 content-scroll p-3 p-md-4">
                    <div className="container-fluid">
                        <Outlet />
                    </div>
                </main>
            </div>
        </div>
    );
}
